import { Switch, Route } from 'react-router-dom';
import Layout from './components/ui/Layout';
import HomePage from './components/pages//homepage/HomePage';
import MealDealPage from './components/pages/meal-deal/MealDealPage';
import LocationsPage from './components/pages/locationspage/LocationsPage';
import MenuPage from './components/pages/menupage/MenuPage';

function App() {
	return (
		<Layout>
			<Switch>
				<Route path='/' exact>
					<HomePage />
				</Route>
				<Route path='/menu'>
					<MenuPage />
				</Route>
				<Route path='/locations'>
					<LocationsPage />
				</Route>
				<Route path='/meal-deal'>
					<MealDealPage />
				</Route>
			</Switch>
		</Layout>
	);
}

export default App;
